import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

import { buildCanonicalLicenseUrl } from '@ts-helpers/license/license-route-context';

export const LicenseCanonicalRedirectGuard: CanActivateFn = route => {
  const router = inject(Router);

  return router.parseUrl(buildCanonicalLicenseUrl(route));
};
